import $ from "jquery";

export default {
    data() {
        return {
            menuOpen: false,
            headerTransparent: false,
            searchOpen: false,
            headerVisibility: true,
            isHome: false
        };
    },
    watch: {
        menuOpen(newVal) {
            if (newVal) {
                $("html").addClass("no-scroll")
                if (this.$refs["full-page"]) {
                    this.$refs["full-page"].disableScroll()
                }
            } else {
                $("html").removeClass("no-scroll")
                if (this.$refs["full-page"]) {
                    this.$refs["full-page"].enableScroll()
                }
            }
        }
    },
    computed: {
        menuTransparent() {
            if (this.isHome) {
                return this.menuOpen || this.headerTransparent
            } else {

                return this.menuOpen ? false : this.headerTransparent
            }
        },
        showHeader() {
            return this.isHome || this.menuOpen ? true : this.headerVisibility
        }
    },
    methods: {
        switchMenu() {
            this.menuOpen = !this.menuOpen
        },
        openSearch() {
            this.searchOpen = true
            this.$nextTick(function () {
                $('#form-search input').focus()
            })
        }
    },
    mounted() {
        this.isHome = $("body").hasClass("home")
    }
};